import { useEffect, useSyncExternalStore } from "react";
import { getPrivateSessionState, subscribePrivateSession } from "@/lib/api/private-session";


import { useQueryClient } from "@tanstack/react-query";
import { resetPrivateState } from "./sessionChannel";
import { invalidatePrivateSession, finishPrivateSessionChange } from "@/lib/api/private-session";
import { signOutAdminFirebaseAuth } from "@/lib/firebase/auth-session";
import { useQuery } from "@tanstack/react-query";
import { readSession, takeSessionCredentialRefresh } from "./readSession";
import { queryKeys } from "@/lib/query/core/query-keys";

export function useSessionQuery() {
  const client = useQueryClient();
  const session = useSyncExternalStore(subscribePrivateSession, getPrivateSessionState);
  const query = useQuery({
    enabled: !session.changing,
    queryKey: queryKeys.admin.session(),
    queryFn: async ({ signal }) => {
      const previous = getPrivateSessionState();
      const payload = await readSession(client, signal);
      if (previous.actorId && previous.actorId !== payload.admin?.id) {
        invalidatePrivateSession();
        const next = getPrivateSessionState().generation;
        await resetPrivateState(client);
        await signOutAdminFirebaseAuth().catch(() => undefined);
        if (next !== getPrivateSessionState().generation) throw new DOMException("Session changed", "AbortError");
      }
      finishPrivateSessionChange(undefined, payload.admin?.id);
      return payload;
    },
    refetchOnWindowFocus: "always",
  });

  const { data, refetch } = query;
  useEffect(() => {
    if (!session.changing && data && takeSessionCredentialRefresh(client)) void refetch();
  }, [client, data, refetch, session.changing]);

  return {
    data: session.changing ? undefined : query.data,
    isLoading: session.changing || query.isLoading,
    error: session.changing ? null : query.error,
    refetch: query.refetch,
  };
}
